import {
    Component,
    Input,
    Output,
    ElementRef,
    OnChanges,
    AfterViewInit,
    SimpleChanges,
    EventEmitter
} from '@angular/core';


import { ProductGroup } from "../model/product.group";
import { Product } from "../model/product";
import { Logger } from "../utils/logger";
import { EventsService } from "../services/events.service";
import $ from "jquery";

@Component({
    selector: 'product-img',
    templateUrl: "./product-image.component.html"
})
export class ProductImage implements AfterViewInit, OnChanges {
    @Input()
    public product: Product;

    @Input()
    public groupName: string;

    @Input()
    public productGroup: ProductGroup;

    @Input()
    public width;

    @Input()
    public height;

    @Input()
    public marginLeft;

    @Input()
    public alternative?: { index: number, groupName: string } = null;

    @Input()
    public savedAlternatives: Array<any>;

    @Output('load')
    public load: EventEmitter<{ product: Product, groupName: string }>;

    public productImageSrc: string;

    public zIndex: number = 0;

    constructor(public el: ElementRef, public logger: Logger, public eventBus: EventsService) {
        this.load = new EventEmitter<{ product: Product, groupName: string }>();
    }

    public hiddenImg: HTMLImageElement;
    public canvasImg: HTMLImageElement;

    ngAfterViewInit(): any {
        // console.info("after init");

        this.hiddenImg = this.el.nativeElement.querySelector('.hidden-img') as HTMLImageElement;
        this.canvasImg = this.el.nativeElement.querySelector('.canvas-img') as HTMLImageElement;
        this.hiddenImg.addEventListener('load', () => {
            // this.logger.debug("product loaded", this.canvasImg);
            $(this.canvasImg).animate({ opacity: 0 }, 1000, () => {
                $(this.canvasImg).css({ opacity: 1 });
            });

            $(this.hiddenImg).animate({ opacity: 1 }, 1000, () => {
                $(this.canvasImg).attr('src', this.hiddenImg.src);
                $(this.hiddenImg).css({ opacity: 0 });
            });

            if (this.product) {
                this.onLoad();
            }
        });

        if (this.savedAlternatives) {
            this.savedAlternatives.forEach(alternative => {
                this.updateProductImageSrc(alternative);
            });
        } else {
            this.updateProductImageSrc({ index: 0, groupName: this.groupName });
        }
    }

    onLoad() {
        if (this.productGroup.getDepthValue) {
            this.zIndex = this.productGroup.getDepthValue() * 10;
        }

        this.load.emit({ product: this.product, groupName: this.groupName });
    }

    ngOnChanges(changes: any): any {
        if (typeof changes.product !== 'undefined') {
            if (changes.product.currentValue !== changes.product.previousValue) {
                if (this.hiddenImg) {
                    let renderPath = changes.product.currentValue.renderPath.getValue() ? changes.product.currentValue.renderPath.getValue() : changes.product.currentValue.renderPath1.getValue();
                    this.hiddenImg.src = renderPath;
                    let alternative = this.alternative ? this.alternative : { index: 0, groupName: this.groupName };
                    this.updateProductImageSrc(alternative);
                }
            }
        }

        if (typeof changes.alternative !== 'undefined' && changes.alternative.currentValue && changes.alternative.currentValue !== changes.alternative.prevoiusValue) {
            this.updateProductImageSrc(changes.alternative.currentValue);
        }
    }

    updateProductImageSrc(alternative: { index: number, groupName: string }) {
        if (alternative.groupName == this.groupName) {
            let renderPath = this.product.renderPath.getValue() ? this.product.renderPath.getValue() : this.product.renderPath1.getValue();

            if (alternative.index > 0) {
                renderPath = this.product.renderPath2.getValue() ? this.product.renderPath2.getValue() : this.product.renderPath1.getValue();
            }

            this.productImageSrc = renderPath;

            this.eventBus.broadcast("products.renderImageLoaded", {
                product: this.product,
                groupName: this.groupName
            });
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/canvas/product-image.component.ts